import { isClient } from '@vista-digital/utilities';
import { autorun, configure } from 'mobx';
import { updateApiClients } from './api-clients/update-api-clients';
import { configurationSettings } from './configuration/configuration-settings';
import { updateIsMemberSignedIn } from './domains/loyalty/actions/member/authentication/update-is-member-signed-in';
import { isMemberSignedIn } from './domains/loyalty/selectors/member/is-member-signed-in';
import { loyaltyDomainStore } from './domains/loyalty/store';
import { hydrateDomainStores } from './domains/stores';
import { handleAppUpdate } from './handle-app-update';
import { vistaDiagnosticLogInstance } from './utils/logger';
export const initialise = (config) => {
    // Enforcing strict use of mobx, [store].data can only be mutated via @action
    configure({ enforceActions: 'observed' });
    handleAppUpdate();
    // Hydrate domain stores
    hydrateDomainStores();
    configurationSettings.setConfig(config);
    // Update the API clients whenever the configuration settings are changed (also executes immediately).
    autorun(() => {
        updateApiClients(configurationSettings.data);
        vistaDiagnosticLogInstance.configure('console', configurationSettings.data.logger);
        updateIsMemberSignedIn(true);
    });
    // TODO: Decide if we should be doing this for all stores. #294875
    // This listener keeps the loyalty store in sync when changes are made in different tabs.
    if (isClient()) {
        window.addEventListener('focus', () => {
            if (isMemberSignedIn())
                loyaltyDomainStore.hydrate();
        });
    }
};
//# sourceMappingURL=initialise.js.map